import { Monitor } from "../../../../types/assessment/monitor.ts";
import {
  partialGrantFixGenerator,
  unusedGrantFixGenerator,
} from "./gcp-fix-generators.ts";

export const GcpGrantPresets = {
  "Unused GCP Role Bindings": Monitor({
    show: "grant",
    scopes: ["gcloud"],
    searchTerm:
      'usage:type:"unused" ^usage:type:!"unused" ^grant=isProviderManaged:"true" identity=status:"active"',
    label: "Unused GCP role binding",
    priority: "HIGH",
    cta: "No privileges given by this role binding have been used in the last 90 days. Consider removing this role binding.",
    remediation: (action: string) =>
      `No privileges given by this grant have been used in the last 90 days. P0 has automatically ${action} to remove this grant.`,
    description:
      "Role binding for which no privileges have been used in the last 90 days.",
    vcsRemediateSupported: true,
    fix: unusedGrantFixGenerator,
  }),
  "Excessive GCP Role Bindings": Monitor({
    scopes: ["gcloud"],
    show: "grant",
    // nodes that can reach an unused permission AND can reach a used or unknown permission
    searchTerm:
      'usage:type:"unused" usage:type:!"unused" ^grant=isProviderManaged:"true"',
    label: "Excessive GCP role bindings",
    priority: "MEDIUM",
    cta: "This role binding has more privileges than are required for its intended use. Consider replacing this role binding with a least-privileged role binding.",
    description:
      "Role bindings with more privileges than are required for their intended use.",
    fix: partialGrantFixGenerator,
  }),
  "Privileged GCP Role Bindings": Monitor({
    scopes: ["gcloud"],
    show: "grant",
    searchTerm: 'risk:"CRITICAL" ^grant=isProviderManaged:"true"',
    label: "Privileged GCP role bindings",
    priority: "MEDIUM",
    cta: "This role binding allows access with critical risks. Consider replacing this role binding with a low-sensitivity role binding, and using just-in-time access for ephemeral access.",
    description:
      "Role bindings with any privileges that allow sensitive access.",
  }),
  "GCP Role Bindings with Unused Privileged Access": Monitor({
    scopes: ["gcloud"],
    show: "grant",
    searchTerm:
      'usage:type:"unused"->risk:"CRITICAL" ^grant=isProviderManaged:"true"',
    label: "GCP role bindings with unused privileged access",
    priority: "CRITICAL",
    cta: "This role binding conveys privileges that allow critical risks, and these privileges have not been used in the last 90 days. Consider replacing this role binding with a role that does not include these privileges.",
    description:
      "Role bindings with unused privileges that allow sensitive access.",
    fix: partialGrantFixGenerator,
  }),
};
